const Status = Object.freeze({
    COMPLETE: "complete",
    ASSIGNED: "assigned",
    IN_PROGRESS: "in_progress",
    OVERDUE: "overdue",
});

export default Status;